import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';

const API = process.env.REACT_APP_BACKEND_URL || '';

export default function MigrasiData() {
  const [routers, setRouters] = useState([]);
  const [routerId, setRouterId] = useState('');
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(false);
  // 2026-07-17: Source type toggle — 'pppoe' (default) atau 'hotspot'
  const [sourceType, setSourceType] = useState('pppoe');

  const [plans, setPlans] = useState([]);
  const [owners, setOwners] = useState([]);
  const [branches, setBranches] = useState([]);
  const [profileMap, setProfileMap] = useState({});
  const [ownerId, setOwnerId] = useState('');
  const [branchId, setBranchId] = useState('');
  const [address, setAddress] = useState('Desa Wonosekar Karangawen Demak');
  const [markPaid, setMarkPaid] = useState(true);
  const [skipExisting, setSkipExisting] = useState(true);
  const [result, setResult] = useState(null);
  const [fixResult, setFixResult] = useState(null);
  const [syncAccResult, setSyncAccResult] = useState(null);
  // 2026-05-29: Bulk Update Jatuh Tempo
  const [bulkDueDate, setBulkDueDate] = useState('');
  const [bulkOwnerId, setBulkOwnerId] = useState('');
  const [bulkMarkLunas, setBulkMarkLunas] = useState(false);
  const [bulkUpdateInvoices, setBulkUpdateInvoices] = useState(true);
  const [bulkDueResult, setBulkDueResult] = useState(null);
  const [bulkPreview, setBulkPreview] = useState(null);
  const [showPreview, setShowPreview] = useState(false);

  const previewBulkDueDate = async () => {
    if (!bulkDueDate) { toast.error('Tanggal jatuh tempo wajib diisi'); return; }
    const scope_owner = bulkOwnerId ? parseInt(bulkOwnerId) : null;
    const scope_router = routerId ? parseInt(routerId) : null;
    if (!scope_owner && !scope_router) {
      toast.error('Pilih owner ATAU router sebagai scope');
      return;
    }
    setLoading(true); setBulkPreview(null);
    try {
      const body = { target_date: bulkDueDate, owner_id: scope_owner, router_id: scope_router, limit: 200 };
      const { data } = await axios.post(`${API}/api/tools/bulk-update-due-date-preview`, body, { headers: headers() });
      setBulkPreview(data);
      setShowPreview(true);
    } catch (e) {
      toast.error('Preview gagal: ' + (e.response?.data?.detail || e.message));
    } finally { setLoading(false); }
  };

  const runBulkDueDate = async () => {
    if (!bulkDueDate) { toast.error('Tanggal jatuh tempo wajib diisi'); return; }
    const scope_owner = bulkOwnerId ? parseInt(bulkOwnerId) : null;
    const scope_router = routerId ? parseInt(routerId) : null;
    if (!scope_owner && !scope_router) {
      toast.error('Pilih owner ATAU router di Step 1 sebagai scope. Tidak bisa kosong dua-duanya.');
      return;
    }
    const scopeText = scope_owner ? `owner #${scope_owner}` : `router #${scope_router}`;
    if (!window.confirm(`Update tanggal jatuh tempo ${scopeText} ke ${bulkDueDate}?

Mark Lunas: ${bulkMarkLunas ? 'YA' : 'tidak'}
Update Invoice & Akuntansi: ${bulkUpdateInvoices ? 'YA' : 'tidak'}

Tindakan tidak bisa di-undo via UI.`)) return;
    setLoading(true); setBulkDueResult(null);
    try {
      const body = {
        target_date: bulkDueDate,
        owner_id: scope_owner,
        router_id: scope_router,
        mark_lunas: bulkMarkLunas,
        update_invoices: bulkUpdateInvoices,
      };
      const { data } = await axios.post(`${API}/api/tools/bulk-update-due-date`, body, { headers: headers() });
      setBulkDueResult(data);
      toast.success(data.message || 'Bulk update sukses', { duration: 7000 });
    } catch (e) {
      toast.error('Bulk update gagal: ' + (e.response?.data?.detail || e.message));
    } finally { setLoading(false); }
  };

  // 2026-05-28: Sync Akuntansi — re-build income_transactions from existing payments
  const syncAccounting = async () => {
    const scopeText = routerId ? `router ${routerId}` : 'semua router (yang Anda kelola)';
    if (!window.confirm(`Sinkronisasi data akuntansi untuk ${scopeText}? Idempotent: row yang sudah ada tidak akan duplikat.`)) return;
    setLoading(true); setSyncAccResult(null);
    try {
      const body = routerId ? { router_id: Number(routerId) } : {};
      const { data } = await axios.post(`${API}/api/tools/sync-accounting`, body, { headers: headers() });
      setSyncAccResult(data);
      toast.success(`Sync akuntansi: ${data.created} baru, ${data.skipped_existing} sudah ada`, { duration: 6000 });
    } catch (e) {
      toast.error("Sync gagal: " + (e.response?.data?.detail || e.message));
    } finally { setLoading(false); }
  };

  const fixOrphan = async () => {
    if (!window.confirm("Akan auto-fix semua customer dengan router_id=NULL dengan mencocokkan PPP secret ke router aktif. Lanjut?")) return;
    setLoading(true); setFixResult(null);
    try {
      const { data } = await axios.post(`${API}/api/tools/fix-orphan-router-id`, {}, { headers: headers() });
      setFixResult(data);
      toast.success(`Fix selesai: ${data.total_fixed} customer diperbaiki`);
    } catch (e) {
      toast.error("Fix gagal: " + (e.response?.data?.detail || e.message));
    } finally { setLoading(false); }
  };

  const headers = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });

  useEffect(() => {
    (async () => {
      try {
        const [r, p, o, b] = await Promise.all([
          axios.get(`${API}/api/mikrotiks`, { headers: headers() }).catch(() => ({ data: { data: [] } })),
          axios.get(`${API}/api/service-plans`, { headers: headers() }).catch(() => ({ data: { data: [] } })),
          axios.get(`${API}/api/owners`, { headers: headers() }).catch(() => ({ data: { data: [] } })),
          axios.get(`${API}/api/branches`, { headers: headers() }).catch(() => ({ data: { data: [] } })),
        ]);
        setRouters((r.data?.data || r.data || []).filter(x => x.is_active !== false));
        setPlans(p.data?.data || p.data || []);
        setOwners(o.data?.data || o.data || []);
        setBranches(b.data?.data || b.data || []);
      } catch (e) { console.error(e); }
    })();
  }, []);

  const fetchPreview = async () => {
    if (!routerId) { toast.error('Pilih router dulu'); return; }
    setLoading(true); setPreview(null); setResult(null);
    try {
      const url = sourceType === 'hotspot'
        ? `${API}/api/tools/migration/preview-hotspot-users/${routerId}`
        : `${API}/api/tools/migration/preview-secrets/${routerId}`;
      const { data } = await axios.get(url, { headers: headers() });
      setPreview(data);
      // pre-set profile map keys
      const initial = {};
      Object.keys(data.profile_count || {}).forEach(p => { initial[p] = ''; });
      setProfileMap(initial);
      const label = sourceType === 'hotspot' ? 'hotspot user' : 'secrets';
      toast.success(`Berhasil fetch ${data.total} ${label}`);
    } catch (e) {
      toast.error('Gagal fetch: ' + (e.response?.data?.detail || e.message));
    } finally { setLoading(false); }
  };

  const execute = async () => {
    if (!preview) return;
    if (!ownerId || !branchId) { toast.error('Pilih Owner & Cabang'); return; }
    const unmapped = Object.entries(profileMap).filter(([k, v]) => !v).map(([k]) => k);
    if (unmapped.length) { toast.error('Belum semua profile di-mapping: ' + unmapped.join(', ')); return; }
    const kindLabel = sourceType === 'hotspot' ? 'Hotspot User' : 'PPPoE Customer';
    if (!window.confirm(`Akan mengimpor ${preview.total} ${kindLabel}. Lanjut?`)) return;
    setLoading(true); setResult(null);
    try {
      const basePayload = {
        router_id: routerId,
        owner_id: parseInt(ownerId),
        branch_id: parseInt(branchId),
        address_default: address,
        mark_as_paid: markPaid,
        skip_existing: skipExisting,
        profile_map: profileMap,
      };
      let url, payload;
      if (sourceType === 'hotspot') {
        url = `${API}/api/tools/migration/import-hotspot-users`;
        payload = { ...basePayload, hotspot_users: preview.hotspot_users };
      } else {
        url = `${API}/api/tools/migration/import-secrets`;
        payload = { ...basePayload, secrets: preview.secrets };
      }
      const { data } = await axios.post(url, payload, { headers: headers() });
      setResult(data);
      toast.success(`Import selesai: ${data.created} dibuat, ${data.skipped} skip`);
    } catch (e) {
      toast.error('Import gagal: ' + (e.response?.data?.detail || e.message));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-slate-50 dark:bg-slate-950 p-6 max-w-5xl mx-auto">
      <h1 className="text-3xl font-bold mb-1">Migrasi Data dari MikroTik</h1>
      <p className="text-sm text-slate-600 mb-6 dark:text-slate-300">Import PPP Secret atau Hotspot User dari router MikroTik menjadi pelanggan beserta tagihan & pembayaran berjalan.</p>

      <div className="bg-white rounded-lg border p-5 mb-4 shadow-sm dark:bg-slate-800">
        <h2 className="font-semibold mb-3 text-slate-800 dark:text-slate-200">1. Pilih Sumber Data</h2>
        <div className="flex gap-3 mb-4">
          <button
            type="button"
            onClick={() => { setSourceType('pppoe'); setPreview(null); setResult(null); }}
            data-testid="source-pppoe"
            className={`flex-1 px-4 py-3 rounded-lg border-2 font-medium transition ${
              sourceType === 'pppoe'
                ? 'border-blue-600 bg-blue-50 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300'
                : 'border-slate-300 bg-white hover:border-blue-400 dark:bg-slate-700 dark:border-slate-600 dark:text-slate-200'
            }`}
          >
            <div className="text-lg font-semibold">PPPoE Secrets</div>
            <div className="text-xs opacity-75 mt-1">Dari /ppp/secret · Untuk pelanggan berlangganan bulanan</div>
          </button>
          <button
            type="button"
            onClick={() => { setSourceType('hotspot'); setPreview(null); setResult(null); }}
            data-testid="source-hotspot"
            className={`flex-1 px-4 py-3 rounded-lg border-2 font-medium transition ${
              sourceType === 'hotspot'
                ? 'border-emerald-600 bg-emerald-50 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-300'
                : 'border-slate-300 bg-white hover:border-emerald-400 dark:bg-slate-700 dark:border-slate-600 dark:text-slate-200'
            }`}
          >
            <div className="text-lg font-semibold">Hotspot Users</div>
            <div className="text-xs opacity-75 mt-1">Dari /ip/hotspot/user · Untuk pelanggan hotspot / WiFi voucher</div>
          </button>
        </div>
      </div>

      <div className="bg-white rounded-lg border p-5 mb-4 shadow-sm dark:bg-slate-800">
        <h2 className="font-semibold mb-3 text-slate-800 dark:text-slate-200">2. Pilih Router</h2>
        <div className="flex gap-2">
          <select value={routerId} onChange={e => setRouterId(e.target.value)} className="flex-1 border rounded px-3 py-2" data-testid="select-router">
            <option value="">— Pilih router —</option>
            {routers.map(r => <option key={r.id} value={r.id}>{r.name} ({r.host}:{r.port}) — {r.branch_name || '-'}</option>)}
          </select>
          <button onClick={fetchPreview} disabled={loading} className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded disabled:opacity-50" data-testid="btn-fetch-preview">
            {loading ? 'Loading...' : (sourceType === 'hotspot' ? 'Fetch Hotspot Users' : 'Fetch Secrets')}
          </button>
        </div>
      </div>

      {preview && (
        <>
          <div className="bg-white rounded-lg border p-5 mb-4 shadow-sm dark:bg-slate-800">
            <h2 className="font-semibold mb-3 text-slate-800 dark:text-slate-200">3. Preview & Mapping Profile</h2>
            <div className="mb-3 text-sm text-slate-700 dark:text-slate-200">
              Router: <b>{preview.router.name}</b> ({preview.router.host}) — Total{' '}
              <b>{sourceType === 'hotspot' ? 'hotspot user' : 'secret'}</b>: <b>{preview.total}</b>
              {sourceType === 'hotspot' && (
                <span className="ml-2 inline-block bg-emerald-100 text-emerald-700 px-2 py-0.5 rounded text-xs dark:bg-emerald-900/40 dark:text-emerald-300">Hotspot Mode</span>
              )}
            </div>
            <div className="space-y-2">
              {Object.entries(preview.profile_count).map(([prof, cnt]) => (
                <div key={prof} className="flex items-center gap-3">
                  <div className="w-40 font-mono text-sm bg-slate-100 px-2 py-1 rounded dark:bg-slate-800">{prof}</div>
                  <div className="text-xs text-slate-500 w-16 dark:text-slate-400">{cnt} pcs</div>
                  <span className="text-slate-400 dark:text-slate-500">→</span>
                  <select value={profileMap[prof] || ''} onChange={e => setProfileMap(m => ({...m, [prof]: e.target.value}))} className="flex-1 border rounded px-3 py-2" data-testid={`map-${prof}`}>
                    <option value="">— Pilih Service Plan —</option>
                    {plans.map(p => <option key={p.id} value={p.id}>{p.name} — Rp {Number(p.price).toLocaleString('id-ID')}</option>)}
                  </select>
                </div>
              ))}
            </div>
          </div>

          <div className="bg-white rounded-lg border p-5 mb-4 shadow-sm dark:bg-slate-800">
            <h2 className="font-semibold mb-3 text-slate-800 dark:text-slate-200">4. Default Data</h2>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium mb-1">Owner</label>
                <select value={ownerId} onChange={e => setOwnerId(e.target.value)} className="w-full border rounded px-3 py-2" data-testid="select-owner">
                  <option value="">— Pilih owner —</option>
                  {owners.map(o => <option key={o.id} value={o.id}>{o.owner_code || o.id} — {o.name}</option>)}
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">Cabang</label>
                <select value={branchId} onChange={e => setBranchId(e.target.value)} className="w-full border rounded px-3 py-2" data-testid="select-branch">
                  <option value="">— Pilih cabang —</option>
                  {branches.map(b => <option key={b.id} value={b.id}>{b.name}</option>)}
                </select>
              </div>
              <div className="col-span-2">
                <label className="block text-sm font-medium mb-1">Alamat Default</label>
                <input value={address} onChange={e => setAddress(e.target.value)} className="w-full border rounded px-3 py-2" data-testid="input-address" />
              </div>
              <div className="col-span-2 flex gap-6">
                <label className="flex items-center gap-2 text-sm">
                  <input type="checkbox" checked={markPaid} onChange={e => setMarkPaid(e.target.checked)} data-testid="chk-mark-paid" />
                  Tandai LUNAS bulan berjalan (buat invoice + payment otomatis)
                </label>
                <label className="flex items-center gap-2 text-sm">
                  <input type="checkbox" checked={skipExisting} onChange={e => setSkipExisting(e.target.checked)} />
                  Skip pelanggan existing (username sudah ada)
                </label>
              </div>
            </div>
          </div>

          <button onClick={execute} disabled={loading} className="w-full px-4 py-3 bg-emerald-600 hover:bg-emerald-700 text-white rounded-lg font-semibold disabled:opacity-50" data-testid="btn-execute-import">
            {loading
              ? 'Memproses...'
              : `Jalankan Import (${preview.total} ${sourceType === 'hotspot' ? 'hotspot user' : 'secrets'})`}
          </button>
        </>
      )}

      <div className="mt-6 bg-amber-50 border border-amber-300 rounded-lg p-4 dark:bg-amber-900/30">
        <h3 className="font-semibold text-amber-900 mb-2">Auto-Fix: router_id NULL</h3>
        <p className="text-sm text-amber-800 mb-3">Perbaiki customer yang router_id-nya NULL (mis. setelah router dihapus). System akan cocokkan pppoe_username dengan /ppp/secret semua router aktif.</p>
        <button onClick={fixOrphan} disabled={loading} className="px-4 py-2 bg-amber-600 hover:bg-amber-700 text-white rounded font-medium disabled:opacity-50" data-testid="btn-fix-orphan">{loading ? "Memproses..." : "Jalankan Auto-Fix router_id"}</button>
        {fixResult && (
          <div className="mt-3 text-sm text-slate-700 bg-white rounded p-3 dark:text-slate-200 dark:bg-slate-800">
            <div>Orphan sebelum: <b>{fixResult.total_orphan_before}</b></div>
            <div>Diperbaiki: <b className="text-emerald-700 dark:text-emerald-300">{fixResult.total_fixed}</b></div>
            <div>Sisa orphan: <b className={fixResult.remaining_orphan > 0 ? "text-red-600" : "text-emerald-700"}>{fixResult.remaining_orphan}</b></div>
            {fixResult.per_router && Object.keys(fixResult.per_router).length > 0 && (
              <details className="mt-2"><summary className="cursor-pointer">Detail per router</summary>
                <pre className="text-xs mt-2">{JSON.stringify(fixResult.per_router, null, 2)}</pre>
              </details>
            )}
          </div>
        )}
      </div>

      {/* 2026-05-29: Bulk Update Jatuh Tempo Card */}
      <div className="mt-4 bg-purple-50 border border-purple-300 rounded-lg p-4 dark:bg-purple-900/30">
        <h3 className="font-semibold text-purple-900 mb-2">Bulk Update Jatuh Tempo + Sync Akuntansi</h3>
        <p className="text-sm text-purple-800 mb-3">
          Ubah <b>next_due_date</b> banyak customer sekaligus (per owner ATAU per router) + sync ke invoice & akuntansi.
          Cocok untuk re-set jatuh tempo setelah bulk-import dari MikroTik.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-3">
          <div>
            <label className="block text-xs font-medium text-slate-700 mb-1 dark:text-slate-200">Tanggal Jatuh Tempo Baru <span className="text-red-500">*</span></label>
            <input type="date" value={bulkDueDate} onChange={(e)=>setBulkDueDate(e.target.value)} className="w-full border rounded px-2 py-1.5 text-sm" data-testid="input-bulk-due-date" />
          </div>
          <div>
            <label className="block text-xs font-medium text-slate-700 mb-1 dark:text-slate-200">Owner (opsional, isi salah satu)</label>
            <select value={bulkOwnerId} onChange={(e)=>setBulkOwnerId(e.target.value)} className="w-full border rounded px-2 py-1.5 text-sm" data-testid="select-bulk-owner">
              <option value="">— Pakai Router dari Step 1 —</option>
              {(owners||[]).map(o => (
                <option key={o.id} value={o.id}>{o.name} (id={o.id})</option>
              ))}
            </select>
          </div>
        </div>
        <div className="flex flex-wrap gap-3 mb-3 text-sm">
          <label className="flex items-center gap-1.5" data-testid="chk-bulk-mark-lunas">
            <input type="checkbox" checked={bulkMarkLunas} onChange={(e)=>setBulkMarkLunas(e.target.checked)} />
            <span>Tandai LUNAS (payment_status=sudah_bayar)</span>
          </label>
          <label className="flex items-center gap-1.5" data-testid="chk-bulk-update-invoices">
            <input type="checkbox" checked={bulkUpdateInvoices} onChange={(e)=>setBulkUpdateInvoices(e.target.checked)} />
            <span>Update Invoice paid + Sync Akuntansi</span>
          </label>
        </div>
        <p className="text-xs text-slate-600 mb-3 italic dark:text-slate-300">
          Scope: {bulkOwnerId ? `Owner #${bulkOwnerId}` : (routerId ? `Router #${routerId} (dari Step 1)` : <span className="text-red-500">Belum ada scope — pilih router di Step 1 atau owner di atas</span>)}
        </p>
        <div className="flex gap-2">
          <button onClick={previewBulkDueDate} disabled={loading || !bulkDueDate || (!bulkOwnerId && !routerId)}
            className="px-4 py-2 bg-slate-200 hover:bg-slate-300 text-slate-800 rounded font-medium disabled:opacity-50 dark:bg-slate-700 dark:text-slate-200"
            data-testid="btn-bulk-preview">
            Preview Dulu
          </button>
          <button onClick={runBulkDueDate} disabled={loading || !bulkDueDate || (!bulkOwnerId && !routerId)}
            className="px-4 py-2 bg-purple-600 hover:bg-purple-700 text-white rounded font-medium disabled:opacity-50"
            data-testid="btn-bulk-update-due-date">
            {loading ? "Memproses..." : "Jalankan Bulk Update"}
          </button>
        </div>
        {showPreview && bulkPreview && (
          <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4" onClick={()=>setShowPreview(false)}>
            <div className="bg-white rounded-xl shadow-2xl w-full max-w-4xl max-h-[90vh] flex flex-col dark:bg-slate-800" onClick={(e)=>e.stopPropagation()}>
              <div className="px-5 py-3 border-b flex items-center justify-between bg-purple-50 dark:bg-purple-900/30">
                <h3 className="font-bold text-purple-900">Preview Bulk Update Jatuh Tempo</h3>
                <button onClick={()=>setShowPreview(false)} className="text-slate-500 hover:text-slate-800 dark:text-slate-400" data-testid="btn-close-preview">✕</button>
              </div>
              <div className="p-4 grid grid-cols-3 gap-3 border-b bg-slate-50 dark:bg-slate-900">
                <div className="text-center"><div className="text-2xl font-bold text-emerald-600 dark:text-emerald-400">{bulkPreview.total}</div><div className="text-xs text-slate-600 dark:text-slate-300">Customer ter-affect</div></div>
                <div className="text-center"><div className="text-2xl font-bold text-blue-600 dark:text-blue-400">{bulkPreview.aggregate?.invoices_to_update}</div><div className="text-xs text-slate-600 dark:text-slate-300">Invoice (Rp {(bulkPreview.aggregate?.invoices_total_amount||0).toLocaleString('id-ID')})</div></div>
                <div className="text-center"><div className="text-2xl font-bold text-indigo-600 dark:text-indigo-400">{bulkPreview.aggregate?.income_missing}</div><div className="text-xs text-slate-600 dark:text-slate-300">Akuntansi belum sync</div></div>
              </div>
              <div className="flex-1 overflow-auto">
                <table className="w-full text-xs">
                  <thead className="bg-slate-100 sticky top-0 dark:bg-slate-800">
                    <tr>
                      <th className="text-left px-2 py-1.5">Nama</th>
                      <th className="text-left px-2 py-1.5">Username</th>
                      <th className="text-left px-2 py-1.5">Due Sekarang → Baru</th>
                      <th className="text-right px-2 py-1.5">Tagihan</th>
                      <th className="text-center px-2 py-1.5">Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(bulkPreview.sample||[]).map(s => (
                      <tr key={s.id} className="border-t hover:bg-purple-50 dark:hover:bg-purple-900/30">
                        <td className="px-2 py-1.5">{s.name}</td>
                        <td className="px-2 py-1.5 font-mono">{s.pppoe_username}</td>
                        <td className="px-2 py-1.5"><span className="text-slate-500 dark:text-slate-400">{s.current_due || '-'}</span> → <span className="font-semibold text-purple-700 dark:text-purple-300">{s.target_due}</span></td>
                        <td className="px-2 py-1.5 text-right font-mono">Rp {(s.monthly_price||0).toLocaleString('id-ID')}</td>
                        <td className="px-2 py-1.5 text-center">{s.is_isolated ? <span className="text-amber-600 dark:text-amber-400">Isolir</span> : (s.is_active ? <span className="text-emerald-600 dark:text-emerald-400">Aktif</span> : <span className="text-slate-500 dark:text-slate-400">Off</span>)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {bulkPreview.total > bulkPreview.sample_count && (
                  <p className="text-center text-xs text-slate-500 py-2 dark:text-slate-400">Menampilkan {bulkPreview.sample_count} dari {bulkPreview.total} customer (preview terbatas).</p>
                )}
              </div>
              <div className="px-5 py-3 border-t flex justify-end gap-2 bg-slate-50 dark:bg-slate-900">
                <button onClick={()=>setShowPreview(false)} className="px-4 py-1.5 text-sm bg-white border rounded dark:bg-slate-800" data-testid="btn-preview-cancel">Tutup</button>
                <button onClick={()=>{ setShowPreview(false); runBulkDueDate(); }} className="px-4 py-1.5 text-sm bg-purple-600 hover:bg-purple-700 text-white rounded font-medium" data-testid="btn-preview-confirm-run">Konfirmasi & Jalankan</button>
              </div>
            </div>
          </div>
        )}
        {bulkDueResult && (
          <div className="mt-3 text-sm bg-white rounded p-3 grid grid-cols-3 gap-3 dark:bg-slate-800">
            <div><div className="text-xl font-bold text-emerald-600 dark:text-emerald-400">{bulkDueResult.customers_updated}</div><div className="text-slate-600 text-xs dark:text-slate-300">Customer</div></div>
            <div><div className="text-xl font-bold text-blue-600 dark:text-blue-400">{bulkDueResult.invoices_updated}</div><div className="text-slate-600 text-xs dark:text-slate-300">Invoice</div></div>
            <div><div className="text-xl font-bold text-indigo-600 dark:text-indigo-400">{bulkDueResult.income_synced}</div><div className="text-slate-600 text-xs dark:text-slate-300">Entry Akuntansi</div></div>
          </div>
        )}
      </div>

      <div className="mt-4 bg-blue-50 border border-blue-300 rounded-lg p-4 dark:bg-blue-900/30">
        <h3 className="font-semibold text-blue-900 mb-2">Sync Akuntansi (dari Payments → Income Transactions)</h3>
        <p className="text-sm text-blue-800 mb-3">
          Membangun ulang entry akuntansi dari payment yang sudah ada (mis. setelah bulk-import migrasi
          dengan opsi "Tandai LUNAS"). Idempotent — payment yang sudah punya entry akuntansi tidak akan diduplikat.
          {routerId ? ` Akan dijalankan untuk router yang dipilih di langkah 1.` : ` Tidak ada router dipilih → akan sync semua router dalam scope Anda.`}
        </p>
        <button onClick={syncAccounting} disabled={loading} className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded font-medium disabled:opacity-50" data-testid="btn-sync-accounting">
          {loading ? "Memproses..." : (routerId ? `Sync Akuntansi (router ${routerId})` : "Sync Akuntansi (semua router)")}
        </button>
        {syncAccResult && (
          <div className="mt-3 text-sm text-slate-700 bg-white rounded p-3 grid grid-cols-3 gap-3 dark:text-slate-200 dark:bg-slate-800">
            <div><div className="text-xl font-bold text-emerald-600 dark:text-emerald-400">{syncAccResult.created}</div><div className="text-slate-600 text-xs dark:text-slate-300">Baru dibuat</div></div>
            <div><div className="text-xl font-bold text-slate-500 dark:text-slate-400">{syncAccResult.skipped_existing}</div><div className="text-slate-600 text-xs dark:text-slate-300">Sudah sinkron</div></div>
            <div><div className="text-xl font-bold text-amber-600 dark:text-amber-400">{syncAccResult.missing_invoice}</div><div className="text-slate-600 text-xs dark:text-slate-300">Tanpa invoice (skip)</div></div>
          </div>
        )}
      </div>

      {result && (
        <div className="mt-6 bg-emerald-50 border-2 border-emerald-300 rounded-lg p-5 dark:bg-emerald-900/30">
          <h3 className="font-bold text-emerald-800 mb-3">Hasil Import</h3>
          <div className="grid grid-cols-4 gap-4 text-sm">
            <div><div className="text-2xl font-bold text-emerald-600 dark:text-emerald-400">{result.created}</div><div className="text-slate-600 dark:text-slate-300">Customer dibuat</div></div>
            <div><div className="text-2xl font-bold text-amber-600 dark:text-amber-400">{result.skipped}</div><div className="text-slate-600 dark:text-slate-300">Skip (existing)</div></div>
            <div><div className="text-2xl font-bold text-purple-600 dark:text-purple-400">{result.invoices_created}</div><div className="text-slate-600 dark:text-slate-300">Invoice dibuat</div></div>
            <div><div className="text-2xl font-bold text-blue-600 dark:text-blue-400">{result.payments_created}</div><div className="text-slate-600 dark:text-slate-300">Payment dibuat</div></div>
          </div>
          {result.isolir > 0 && <div className="mt-3 text-sm text-slate-700 dark:text-slate-200">{result.isolir} customer di-set status ISOLIR (disabled)</div>}
          {result.disabled > 0 && <div className="mt-3 text-sm text-slate-700 dark:text-slate-200">{result.disabled} hotspot user di-set status disabled (nonaktif di RADIUS)</div>}
          {result.errors?.length > 0 && (
            <details className="mt-3">
              <summary className="cursor-pointer text-red-700 font-medium dark:text-red-300">Errors ({result.errors.length})</summary>
              <pre className="text-xs mt-2 bg-white p-2 rounded max-h-60 overflow-auto dark:bg-slate-800">{result.errors.join('\n')}</pre>
            </details>
          )}
        </div>
      )}
    </div>
  );
}
